/**
 * SuperadminRoute
 * Beskytter ruter som krever superadmin-rolle
 */

import React from 'react';
import { Navigate } from 'react-router-dom';
import { Loader } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

interface SuperadminRouteProps {
  children: React.ReactNode;
}

const SuperadminRoute: React.FC<SuperadminRouteProps> = ({ children }) => {
  const { user, loading, hasRole } = useAuth();

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen bg-gray-50">
        <div className="flex flex-col items-center gap-3">
          <Loader size={48} className="animate-spin text-blue-600" />
          <p className="text-gray-600">Laster...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!hasRole('superadmin')) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};

export default SuperadminRoute;
